import { BLOOMREACH_ACTIONS, BLOOMREACH_EVENT } from '../Constants/BloomreachConstants.js';
import { br_trackingEnabled } from './Bloomreach.js';

const br_cartAddition = (payload) => {
  br_cartUpdate(BLOOMREACH_ACTIONS.ADD, payload);
};

const br_cartRemove = (payload) => {
  br_cartUpdate(BLOOMREACH_ACTIONS.REMOVE, payload);
};

const br_cartUpdate = (action, cart) => {
  const bloomreachEnabled = window._THULEDATA?.Bloomreach?.IsEnabled === true;
  const exponeaMissing = typeof exponea === 'undefined';
  const cartMissing = !cart;

  if (bloomreachEnabled && window.Cookiebot?.consent?.marketing === true && (exponeaMissing || cartMissing)) {
    console.error('Bloomreach cart_update aborted due to missing dependencies', {
      action,
      bloomreachEnabled,
      exponeaMissing,
      cartMissing,
      href: window.location.href,
    });
  }

  if (!br_trackingEnabled() || !cart) return;
  let productList = [];
  if (cart.lineItems?.length > 0) {
    productList = cart.lineItems.map((item) => {
      return { id: item.key, quantity: item.quantity };
    });
  }
  exponea.track(BLOOMREACH_EVENT.CART_UPDATE, {
    action: action,
    productList: productList,
    totalQuantity: getTotalQuantity(cart.lineItems),
    totalPrice: cart.totalPrice,
  });
};

const getTotalQuantity = (lineItems) => {
  if (!Array.isArray(lineItems)) return 0;
  let total = 0;
  for (const item of lineItems) {
    const qty = Number(item?.quantity);
    if (!Number.isNaN(qty)) {
      total += qty;
    }
  }
  return total;
};
export { br_cartAddition, br_cartRemove };
